import PropTypes from 'prop-types';
import React from 'react';
import { adjustStringLength } from '@utils/navigationHelpers';
import { displayNameLimits } from '@data/navigation';
import NavigationLinkItem from './NavigationLinkItem';

const HeaderStaticNavigationList = ({ itemData }) => {
  const staticItems = itemData?.filter((item) => item.type !== 'Multiple');

  return (
    <ul className="static-nav-list mb-0 pl-0 d-none d-md-flex flex-nowrap transaction-nav">
      {staticItems.map((item) => {
        const [navLink] = item.links;
        return (
          <NavigationLinkItem
            fullName={navLink.title}
            href={navLink.link}
            key={`${navLink.title}`}
            name={adjustStringLength(navLink.title, displayNameLimits.headerStaticTitle)}
            source={navLink.source}
            type="static"
          />
        );
      })}
    </ul>
  );
};

const itemLinkType = PropTypes.shape({
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
});

const itemsType = PropTypes.shape({
  links: PropTypes.arrayOf(itemLinkType),
  title: PropTypes.string,
});

HeaderStaticNavigationList.propTypes = {
  itemData: PropTypes.arrayOf(itemsType).isRequired,
};

export default HeaderStaticNavigationList;
